/* LUXURIA – Ambiente-Konfigurator. Wird nur geladen, wenn layout/theme.liquid das Produkt als
   Ambientebeleuchtung erkennt (automatische Kollektion "ambientebeleuchtung", Ausschlüsse siehe dort).
   Stand vor der Einführung: Git-Tag "referenz-vor-ambient-prototyp".

   Die Produktoptionen-App (APO) bleibt die einzige Quelle für Optionen, Preise, Regeln, Pflichtfelder und
   Warenkorb-Eigenschaften. Dieses Skript stellt die vorhandenen APO-Auswahlfelder nur anders dar:
   - ordnet die Felder in drei Gruppen (Im Grundpaket enthalten / Angaben zu deinem Fahrzeug / Erweiterungen),
   - zeigt Felder mit bis zu 3 kurzen Werten als Auswahl-Schalter statt als Dropdown (das Dropdown bleibt
     unsichtbar im Formular und wird bei jedem Klick gesetzt – APO rechnet und prüft wie bisher),
   - zeigt eine Preisübersicht: Grundpreis, gewählte Aufpreise (aus den APO-Texten) und den Gesamtpreis,
     den APO selbst berechnet.
   Findet das Skript die APO-Felder nicht, ändert es nichts. */
(function () {
  'use strict';

  var cfg = window.luxAmbient;
  if (!cfg) return;

  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var money = function (cents) { return fmt.format(cents / 100); };
  var fmt0 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
  // Auf den Schaltern ohne ",00" (kürzer, v. a. mobil) – in der Preisübersicht immer mit Cent
  var moneyShort = function (cents) { return cents % 100 === 0 ? fmt0.format(cents / 100) : money(cents); };
  var PRICE_RE = /\s*\(\+\s*([\d.,]+)\s*€\)\s*$/;

  function surcharge(text) {
    var m = PRICE_RE.exec(text || '');
    if (!m) return 0;
    var raw = m[1];
    if (/,\d{2}$/.test(raw)) raw = raw.replace(/\./g, '').replace(',', '.');
    else raw = raw.replace(/,/g, '');
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  // Nur Anzeige-Kürzung – der gespeicherte Wert (Warenkorb/Auftrag) bleibt der APO-Text
  function shortLabel(text) {
    var t = (text || '').replace(PRICE_RE, '').replace(/\s+/g, ' ').trim();
    if (/^nicht gewünscht$/i.test(t) || /^nein,? nicht vorhanden$/i.test(t)) return 'Nein';
    if (/^ja,? (bereits|ist|sind) vorhanden$/i.test(t)) return 'Ja, vorhanden';
    var m = /^ja,?\s*möchte ich haben\s*(.*)$/i.exec(t);
    if (m) {
      var rest = m[1].replace(/^[–-]\s*/, '').replace(/^für\s+/i, '').trim();
      if (/^\(.*\)$/.test(rest)) rest = rest.slice(1, -1);
      if (!rest) return 'Ja';
      return rest.charAt(0).toUpperCase() + rest.slice(1);
    }
    return t;
  }

  function shortTitle(text) {
    return (text || '').replace(/\s*gewünscht\??\s*$/i, '').replace(/\?\s*$/, '').replace(/\s+/g, ' ').trim();
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; });
  }

  var VEHICLE_RE = /vorhanden|verbaut|baujahr|version|mbux|idrive|steuerung|ntg|mmi|navigation|ausstattung|lenkrad/i;

  function readOption(root, idx) {
    var sel = root.querySelector('select');
    if (!sel) return null;
    var titleEl = root.querySelector('.mw-text--style-strong');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var values = [];
    Array.prototype.forEach.call(sel.options, function (o, i) {
      if (!o.value || /wähle/i.test(o.text)) return; // Platzhalter
      values.push({ index: i, text: o.text, label: shortLabel(o.text), price: surcharge(o.text) });
    });
    if (!values.length) return null;
    // „Im Grundpaket enthalten" nur, wenn es genau einen kostenlosen Wert gibt, den APO bereits gewählt hat –
    // sonst muss der Kunde ihn selbst wählen können (Schalter mit einem Wert)
    var included = values.length === 1 && values[0].price === 0 && sel.selectedIndex === values[0].index;
    var kind = included ? 'included' : (VEHICLE_RE.test(title) ? 'vehicle' : 'extra');
    // Einzelwert-Felder, die nur informieren (z. B. „Informationen bei nicht vorhandener …"), sind keine enthaltene Leistung
    if (included && /^(informationen?|hinweis)/i.test(title)) kind = 'note';
    var longest = values.reduce(function (n, v) { return Math.max(n, v.label.length); }, 0);
    // Schalter nur, wenn sie kompakt bleiben: 2 Werte bis 60 Zeichen, 3 Werte bis 42 Zeichen – sonst Dropdown
    var fits = (values.length === 1 && longest <= 60) || (values.length === 2 && longest <= 60) || (values.length === 3 && longest <= 42);
    var control = included ? 'included' : (fits ? 'segments' : 'select');
    // Ja/Nein-Fragen mit kurzen Werten: Titel links, kleiner Schalter rechts in derselben Zeile
    var compact = control === 'segments' && values.length === 2 && longest <= 14 &&
      values.every(function (v) { return /^(ja|nein)\b/i.test(v.label); });
    if (compact) values.forEach(function (v) { v.label = /^ja\b/i.test(v.label) ? 'Ja' : 'Nein'; });
    var short = control === 'segments' && values.length === 3 && longest <= 14;
    return { root: root, select: sel, title: title, values: values, kind: kind, control: control, compact: compact, short: short, id: 'LuxAmb' + idx };
  }

  function build(info, container, options) {
    var body = document.body;
    var base = cfg.price;

    /* ---------- Preiszeile oben ---------- */
    var themePrice = info.querySelector('.price');
    var priceLine = el('div', 'lux-amb-price',
      '<span class="lux-amb-price__value">ab ' + money(base) + '</span>' +
      (cfg.compare && cfg.compare > base ? '<s class="lux-amb-price__compare">' + money(cfg.compare) + '</s>' : '') +
      '<span class="lux-amb-price__tax">inkl. MwSt.</span>');
    if (themePrice && themePrice.parentNode) themePrice.parentNode.insertBefore(priceLine, themePrice);

    /* ---------- Gruppen (Reihenfolge nur innerhalb des APO-Containers, keine Felder werden kopiert) ---------- */
    var groups = [
      { kind: 'included', title: 'Im Grundpaket enthalten', hint: 'Bereits im Preis von ' + money(base) + ' enthalten.' },
      { kind: 'note', title: 'Wichtiger Hinweis', hint: '' },
      { kind: 'vehicle', title: 'Angaben zu deinem Fahrzeug', hint: 'Damit wir die Nachrüstung passend für dein Fahrzeug vorbereiten.' },
      { kind: 'extra', title: 'Erweiterungen', hint: 'Optional – der Aufpreis steht direkt an der Auswahl.' }
    ];
    var intro = el('div', 'lux-amb-intro', '<p class="lux-amb-intro__title">Ausstattung konfigurieren</p>');
    container.insertBefore(intro, container.firstChild);
    var anchor = intro;
    groups.forEach(function (g) {
      var list = options.filter(function (o) { return o.kind === g.kind; });
      if (!list.length) return;
      var head = el('div', 'lux-amb-head lux-amb-head--' + g.kind,
        '<p class="lux-amb-head__title">' + esc(g.title) + '</p>' + (g.hint ? '<p class="lux-amb-head__hint">' + esc(g.hint) + '</p>' : ''));
      container.insertBefore(head, anchor.nextSibling);
      anchor = head;
      list.forEach(function (o) {
        container.insertBefore(o.root, anchor.nextSibling);
        anchor = o.root;
      });
    });

    /* ---------- Darstellung je Feld ---------- */
    options.forEach(function (o) {
      o.root.classList.add('lux-amb-opt', 'lux-amb-opt--' + o.kind, 'lux-amb-opt--' + o.control);
      if (o.compact) o.root.classList.add('lux-amb-opt--compact');
      if (o.short) o.root.classList.add('lux-amb-opt--short');
      if (o.control === 'select') return; // Dropdown bleibt sichtbar (nur Optik per CSS)
      var titleEl = o.root.querySelector('.mw-text--style-strong');
      if (titleEl) titleEl.id = o.id + 'T';
      o.select.classList.add('lux-amb-native');
      o.select.tabIndex = -1;
      o.select.setAttribute('aria-hidden', 'true');
      var box = o.select.closest('.mw-option__container') || o.select.parentNode;

      if (o.control === 'included') {
        var v = o.values[0];
        o.ui = el('p', 'lux-amb-included', '<span class="lux-amb-included__check" aria-hidden="true"></span><span>' + esc(v.label) + '</span>');
        box.parentNode.insertBefore(o.ui, box);
        return;
      }

      o.ui = el('div', 'lux-amb-seg lux-amb-seg--' + o.values.length);
      o.ui.setAttribute('role', 'radiogroup');
      if (titleEl) o.ui.setAttribute('aria-labelledby', titleEl.id);
      o.values.forEach(function (v) {
        var b = el('button', 'lux-amb-seg__btn');
        b.type = 'button';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', 'false');
        b.dataset.index = v.index;
        var price = o.compact ? '' : (v.price > 0 ? '+' + moneyShort(v.price) : (o.kind === 'extra' ? '+0 €' : ''));
        b.innerHTML = '<span class="lux-amb-seg__label">' + esc(v.label) + '</span>' +
          (price ? '<span class="lux-amb-seg__price">' + price + '</span>' : '');
        b.title = v.text.replace(PRICE_RE, '');
        o.ui.appendChild(b);
      });
      o.ui.addEventListener('click', function (e) {
        var b = e.target.closest('.lux-amb-seg__btn');
        if (!b || b.disabled) return;
        o.select.selectedIndex = +b.dataset.index;
        o.select.dispatchEvent(new Event('input', { bubbles: true }));
        o.select.dispatchEvent(new Event('change', { bubbles: true }));
        schedule();
      });
      o.ui.addEventListener('keydown', function (e) {
        if (!/^Arrow(Up|Down|Left|Right)$/.test(e.key)) return;
        e.preventDefault();
        var btns = Array.prototype.filter.call(o.ui.children, function (x) { return !x.disabled; });
        var cur = btns.indexOf(document.activeElement);
        var next = btns[(cur + (/Right|Down/.test(e.key) ? 1 : btns.length - 1)) % btns.length];
        if (next) { next.click(); next.focus(); }
      });
      box.parentNode.insertBefore(o.ui, box);
      // Kompakt: Aufpreis unter dem Titel statt auf dem Schalter
      var paid = o.values.filter(function (v) { return v.price > 0; });
      if (o.compact && paid.length && titleEl) {
        var hint = el('span', 'lux-amb-inline-price', '+' + moneyShort(paid[0].price));
        titleEl.parentNode.appendChild(hint);
      }
    });

    /* ---------- Preisübersicht ---------- */
    var summary = el('div', 'lux-amb-sum',
      '<p class="lux-amb-sum__title">Deine Konfiguration</p>' +
      '<dl class="lux-amb-sum__list"></dl>');
    // Kein eigener Gesamtpreis: direkt darunter steht der Live-Gesamtpreis der App (.mw-apo-price-custom)
    var actions = info.querySelector('.product-actions');
    if (actions && actions.parentNode) actions.parentNode.insertBefore(summary, actions);
    var list = summary.querySelector('.lux-amb-sum__list');


    function apoTotal() {
      var t = info.querySelector('.mws-price .mws-subtotal-price span:last-child');
      if (!t) return null;
      var raw = t.textContent.replace(/[^\d,.]/g, '');
      if (!raw) return null;
      var n = parseFloat(raw.replace(/\./g, '').replace(',', '.'));
      return isNaN(n) ? null : Math.round(n * 100);
    }

    function sync() {
      var rows = '<div class="lux-amb-sum__row"><dt>Grundpreis</dt><dd>' + money(base) + '</dd></div>';
      var sum = base;
      options.forEach(function (o) {
        var hidden = o.root.classList.contains('mw-hidden');
        if (o.ui && o.control === 'segments') {
          Array.prototype.forEach.call(o.ui.children, function (b) {
            var opt = o.select.options[+b.dataset.index];
            var on = !hidden && o.select.selectedIndex === +b.dataset.index;
            b.setAttribute('aria-checked', on ? 'true' : 'false');
            b.classList.toggle('is-selected', on);
            b.disabled = !opt || opt.disabled;
          });
          var any = Array.prototype.some.call(o.ui.children, function (b) { return b.classList.contains('is-selected'); });
          Array.prototype.forEach.call(o.ui.children, function (b, i) {
            b.tabIndex = (b.classList.contains('is-selected') || (!any && i === 0)) ? 0 : -1;
          });
        }
        if (hidden) return;
        var cur = o.select.options[o.select.selectedIndex];
        var p = cur ? surcharge(cur.text) : 0;
        if (p > 0) {
          sum += p;
          rows += '<div class="lux-amb-sum__row"><dt><span>' + esc(shortTitle(o.title)) + '</span><small>' + esc(shortLabel(cur.text)) + '</small></dt><dd>+' + money(p) + '</dd></div>';
        }
      });
      list.innerHTML = rows;
      var total = apoTotal();
      // Gesamtpreis kommt von APO; stimmt die Aufschlüsselung nicht mit APO überein, wird sie nicht gezeigt
      summary.classList.toggle('is-mismatch', total !== null && total !== sum);

      var bar = document.querySelector('.lux-pbar__price');
      if (bar) bar.textContent = money(total !== null ? total : sum);
    }

    var timer = null;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(sync, 60);
      setTimeout(sync, 300); // APO setzt abhängige Felder (Regeln) teils verzögert
    }
    container.addEventListener('change', schedule);
    // Nur auf APO reagieren (Regeln blenden Felder/Werte aus, Preisbox wird neu erzeugt) – nicht auf die eigene Oberfläche
    var own = function (n) { return n.nodeType === 1 && n.closest && n.closest('.lux-amb-seg, .lux-amb-sum, .lux-amb-included, .lux-amb-head, .lux-amb-intro'); };
    var watch = function (list) {
      for (var i = 0; i < list.length; i++) if (!own(list[i].target)) { schedule(); return; }
    };
    new MutationObserver(watch).observe(container, { subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });
    if (actions && actions.parentNode) new MutationObserver(watch).observe(actions.parentNode, { childList: true });
    sync();
    body.classList.add('lux-amb-ready');
  }

  function start() {
    var info = document.querySelector('.product-info');
    if (!info) return;
    var tries = 0;
    var attempt = function () {
      var container = info.querySelector('.mw-apo-container');
      var roots = container ? Array.prototype.filter.call(container.children, function (c) { return c.classList.contains('mw-option'); }) : [];
      if (!roots.length) return false;
      if (!attempt.settled) { attempt.settled = true; setTimeout(attempt, 300); return true; }
      var options = roots.map(readOption).filter(Boolean);
      if (options.length !== roots.length) return true; // unerwartete Feldtypen: nichts umbauen
      build(info, container, options);
      return true;
    };
    if (attempt()) return;
    var mo = new MutationObserver(function () {
      if (++tries > 400) { mo.disconnect(); return; }
      if (attempt()) mo.disconnect();
    });
    mo.observe(info, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
